/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_RankInputs */

const vi_shop_group_rank = /** @type {(inputs: Shop_Group_RankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ hạng Bán chạy (trống = không)`)
};

/**

* @param {Shop_Group_RankInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_rank = /** @type {((inputs?: Shop_Group_RankInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_RankInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_rank(inputs)
});